import React from 'react';
import KegelTimer from '../components/KegelTimer';
import { translations } from '../data/translations';
import './Home.css';

const Home = ({ settings, language, onBackgroundChange, onTimerRunChange }) => {
  const handleExerciseComplete = () => {
    alert(translations[language].completed);
  };

  return (
    <div className="home-page">
      <KegelTimer
        settings={settings}
        language={language}
        onComplete={handleExerciseComplete}
        onBackgroundChange={onBackgroundChange}
        onRunStateChange={onTimerRunChange}
      />
    </div>
  );
};

export default Home;
